/* Static Society — motion controller.
   Product tiles are deliberately excluded: animating them during scroll
   made the grid shift under the thumb. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lightUp(){ document.documentElement.classList.add('ss-lit'); }
  if(reduce){ lightUp(); }
  else { requestAnimationFrame(function(){ requestAnimationFrame(lightUp); }); }

  if(reduce) return;

  var selectors = [
    '.ss-rail__head',
    '.ss-colhd',
    '.ss-close__lines',
    '.ss-signal__copy',
    '.ss-signal__form'
  ];

  var marked = [];
  selectors.forEach(function(sel){
    Array.prototype.forEach.call(document.querySelectorAll(sel), function(el){
      if(el.hasAttribute('data-rv')) return;
      el.setAttribute('data-rv','');
      marked.push(el);
    });
  });

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('rv-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -4% 0px' });
    marked.forEach(function(el){ io.observe(el); });
  } else {
    marked.forEach(function(el){ el.classList.add('rv-in'); });
  }

  var frames = document.querySelectorAll('.ss-close__m');
  if(!frames.length) return;

  var active = [], ticking = false;

  var pio = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ if(active.indexOf(e.target) < 0) active.push(e.target); }
      else { var i = active.indexOf(e.target); if(i > -1) active.splice(i,1); }
    });
    request();
  }, { threshold: 0 });

  Array.prototype.forEach.call(frames, function(f){ pio.observe(f); });

  function paint(){
    ticking = false;
    var vh = window.innerHeight;
    active.forEach(function(f){
      var img = f.querySelector('img');
      if(!img) return;
      var r = f.getBoundingClientRect();
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      p = Math.max(-1, Math.min(1, p));
      img.style.transform = 'scale(1.16) translate3d(0,' + (p * -4).toFixed(2) + '%,0)';
    });
  }

  function request(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(paint);
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  request();
})();
